import { render, staticRenderFns } from "./bay.vue?vue&type=template&id=32ae92f8&"
import script from "./bay.vue?vue&type=script&lang=js&"
export * from "./bay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports